<template>
  <svg
    class="h-full"
    viewBox="0 0 1280 942"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid slice"
  >
    <g clip-path="url(#clip0_4310_2993)">
      <rect width="1280" height="942" fill="#FDF5D0" />
      <g clip-path="url(#clip1_4310_2993)">
        <path
          d="M256.5 173C305.929 173 346 213.071 346 262.5C346 311.929 305.929 352 256.5 352H32.75C8.03526 352 -12 331.965 -12 307.25C-12 282.535 8.03526 262.5 32.75 262.5H81.3193C90.5342 236.429 115.398 217.75 144.625 217.75C155.626 217.75 166.009 220.397 175.172 225.088C189.339 194.342 220.427 173 256.5 173Z"
          fill="white"
        />
      </g>
      <g clip-path="url(#clip2_4310_2993)">
        <path
          d="M826 -59C886.751 -59 936 -9.52747 936 51.5C936 112.527 886.751 162 826 162H551C520.624 162 496 137.264 496 106.75C496 76.2363 520.624 51.5 551 51.5H610.695C622.021 19.3117 652.579 -3.75 688.5 -3.75C702.021 -3.75 714.782 -0.483036 726.044 5.30859C743.456 -32.6509 781.664 -59 826 -59Z"
          fill="white"
        />
      </g>
      <circle cx="952" cy="252" r="92" fill="#F8D744" />
      <path
        d="M949.877 296.151C950.68 295.884 951.55 296.32 951.817 297.123C952.084 297.926 951.648 298.796 950.844 299.063C941.009 302.336 930.842 303.47 920.358 302.471C919.515 302.39 918.895 301.642 918.975 300.799C919.056 299.957 919.804 299.34 920.647 299.419C930.714 300.379 940.453 299.287 949.877 296.151Z"
        fill="black"
      />
      <path
        d="M970.796 241.528C971.49 241.691 972.227 241.35 972.538 240.678C972.893 239.91 972.557 238.998 971.789 238.643L970.994 238.288C963.016 234.86 953.948 234.796 946.739 238.068L946.022 238.405L945.76 238.572C945.198 239.009 945 239.794 945.327 240.459C945.655 241.123 946.4 241.445 947.09 241.263L947.382 241.157L948.651 240.58C955.117 237.893 963.306 238.098 970.502 241.425L970.796 241.528Z"
        fill="black"
      />
      <path
        d="M907.943 241.528C908.637 241.691 909.374 241.35 909.685 240.678C910.04 239.91 909.704 238.998 908.936 238.643L908.141 238.288C900.163 234.86 891.095 234.796 883.886 238.068L883.169 238.405L882.907 238.572C882.345 239.009 882.147 239.794 882.474 240.459C882.802 241.123 883.547 241.445 884.237 241.263L884.528 241.157L885.798 240.58C892.264 237.893 900.453 238.098 907.649 241.425L907.943 241.528Z"
        fill="black"
      />
      <path
        d="M913.667 227.467C913.667 226.62 914.353 225.934 915.2 225.934C916.047 225.934 916.733 226.62 916.733 227.467V268.639L930.884 271.976L931.177 272.074C931.825 272.373 932.194 273.096 932.025 273.817C931.855 274.539 931.202 275.022 930.488 275L930.183 274.958L914.849 271.347C914.157 271.184 913.667 270.566 913.667 269.855V227.467Z"
        fill="black"
      />
      <path
        d="M907.644 206.824C908.342 206.976 909.074 206.623 909.374 205.945C909.673 205.268 909.443 204.488 908.862 204.075L908.59 203.924C898.339 199.391 886.447 199.361 877.267 203.743C876.503 204.107 876.177 205.023 876.541 205.787C876.906 206.551 877.822 206.874 878.586 206.51C886.881 202.55 897.836 202.519 907.35 206.726L907.644 206.824Z"
        fill="black"
      />
      <path
        d="M974.548 206.824C975.245 206.976 975.978 206.623 976.278 205.945C976.577 205.268 976.347 204.488 975.766 204.075L975.494 203.924C965.243 199.391 953.351 199.361 944.171 203.743C943.407 204.107 943.081 205.023 943.445 205.787C943.81 206.551 944.726 206.874 945.49 206.51C953.785 202.55 964.74 202.519 974.254 206.726L974.548 206.824Z"
        fill="black"
      />
      <rect y="822" width="1280" height="120" fill="#68C5FF" />
      <path
        d="M8 714C219.285 714 397.225 771.141 450.63 848.919C669.125 863.02 836 938.85 836 1030.28C836 1131.75 630.499 1214 377 1214C165.714 1214 -12.2274 1156.86 -65.6309 1079.08C-284.126 1064.98 -451 989.15 -451 897.718C-451 796.253 -245.499 714 8 714Z"
        fill="#FAE173"
      />
      <path
        d="M191.708 425C199.745 425 206.26 431.515 206.26 439.552V708.59C218.551 707.149 228.088 696.7 228.088 684.022V625.815C228.088 617.779 234.603 611.263 242.64 611.263C250.676 611.263 257.191 617.779 257.191 625.815V684.022C257.191 712.782 234.643 736.274 206.26 737.786V828.089H177.156V641.018C148.773 639.506 126.225 616.014 126.225 587.254V483.936C126.225 475.899 132.74 469.383 140.776 469.383C148.813 469.383 155.328 475.899 155.328 483.936V587.254C155.328 599.932 164.865 610.38 177.156 611.82V439.552C177.156 431.515 183.671 425 191.708 425Z"
        fill="#00910A"
      />
      <g clip-path="url(#clip3_4310_2993)">
        <path
          d="M1074 252C1028.71 252 992 288.713 992 334C992 379.287 1028.71 416 1074 416H1279C1301.64 416 1320 397.644 1320 375C1320 352.356 1301.64 334 1279 334H1234.5C1226.06 310.114 1203.28 293 1176.5 293C1166.42 293 1156.91 295.425 1148.51 299.723C1135.53 271.553 1107.05 252 1074 252Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4310_2993">
        <rect width="1280" height="942" fill="white" />
      </clipPath>
      <clipPath id="clip1_4310_2993">
        <rect
          width="358"
          height="179"
          fill="white"
          transform="translate(-12 173)"
        />
      </clipPath>
      <clipPath id="clip2_4310_2993">
        <rect
          width="440"
          height="221"
          fill="white"
          transform="translate(496 -59)"
        />
      </clipPath>
      <clipPath id="clip3_4310_2993">
        <rect
          width="328"
          height="164"
          fill="white"
          transform="matrix(-1 0 0 1 1320 252)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
